<h2 mat-dialog-title>Confirm ACH payment</h2>
<mat-dialog-content class="mat-typography">
  <p>Please confirm your payment with ACH transfer</p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Cancel</button>
  <button mat-button [mat-dialog-close]="true" cdkFocusInitial>Confirm</button>
</mat-dialog-actions>